import { Route } from "@angular/router";
import { VTComponent } from "./vt.component";
import { PorteurListRouting } from "./porteur-list/porteur-list.routing";
import { PorteurDetailsRouting } from "./porteur-details/porteur-details.routing";
import { PorteurAddRouting } from "./porteur-add/porteur-add.routing";

export const VTRouting: Route = {
    path: "vt",
    component: VTComponent,
    children: [
      PorteurListRouting,
      PorteurAddRouting,
      PorteurDetailsRouting, 
      {path: "", redirectTo: "porteurs", pathMatch:"full"},
    ],
    data: {
        breadcrumb: "Vêtements de travail"
    }
}
